// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__IB12X","errorLogs":"styles_errorLogs__dB_cR"};